module.exports = __webpack_public_path__ + "files/OBSERVA4.b74fd7cfaa206e278b50059b625c933b.zip";